export enum EPusherSystemEvents {
  Connected = 'connected',
  Error = 'error',
  Disconnected = 'disconnected',
}

export enum EPusherEvents {
  ShopifyProductsSyncComplete = 'shopify-products-sync-complete',
}

export interface IPusherReducer {
  event: EPusherSystemEvents | EPusherEvents,
  data: any,
}

